exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body[data-v-74bc6182] {\n  margin-top: 48px;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  border: 2px solid #b1b4cd;\n  padding: 12px;\n  border-radius: 8px;\n  width: 800px;\n  height: 600px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74bc6182","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/eventCreationPrompt.vue
// module id = L92P
// module chunks = 1